import { BaseDto } from '../../core';
import {
  PAYMENT_METHOD,
  REFUND_METHOD,
  PURCHASE_ORDER_ADMIN_STATUS,
  PURCHASE_ORDER_PARTIAL_REFUND_STATUS,
  FileAttachmentDto,
} from '../../shared';
import { Buyer } from '../buyer/buyer.entity';
import { PurchaseOrderShipping } from './purchase-order-shipping.entity';
import { PurchaseOrderPayment } from './purchase-order-payment.entity';
import { PurchaseOrderProduct } from './purchase-order-product.entity';
import { PurchaseOrderSampleProduct } from './purchase-order-sample-product.entity';
import { PurchaseOrderBuyer } from './purchase-order-buyer.entity';
import { Ledger } from '../ledger/ledger.entity';
import { Inquiry } from '../inquiry/inquiry.entity';
import { BuyerCoupon } from '../coupon/buyer-coupon.entity';
import { PointSetting } from '../wallet';

export class PurchaseOrder extends BaseDto<PurchaseOrder> {
  constructor(partial?: any) {
    super(partial);
  }
  id: number;
  orderNumber: number;
  buyerCompanyId: number;
  buyerId: number;
  itemPrice: number;
  shippingFee: number;
  discount: number;
  discountCoupon: number;
  discountShippingFee: number;
  credit: number;
  point: number;
  refundCredit: number;
  refundPoint: number;
  quantity: number;
  refundQuantity: number;
  refundItems: number;
  items: number;
  purchasePrice: number;
  paymentPrice: number;
  refundFee: number;
  refundPrice: number;
  paymentMethod: PAYMENT_METHOD;
  refundMethod: REFUND_METHOD;
  bankNationality: string;
  bankName: string;
  brandName: string;
  productName: string;
  productImage: string;
  isAccountSaved: boolean;
  ttAttachment: FileAttachmentDto[];
  accountHolder: string;
  refundBankName: string;
  refundBankAddress: string;
  refundSwiftCode: string;
  refundAccountNumber: string;
  refundAccountHolder: string;
  purchaseReason: string;
  purchaseOrderStatus: PURCHASE_ORDER_ADMIN_STATUS;
  purchaseOrderPartialRefundStatus: PURCHASE_ORDER_PARTIAL_REFUND_STATUS;
  purchaseOrderStatusUpdated: Date;
  adminId: number;
  created: Date;
  updated: Date;
  cancelled: Date;
  refunded: Date;
  buyer?: Buyer;
  orderBuyer?: PurchaseOrderBuyer;
  products?: PurchaseOrderProduct[];
  shipping?: PurchaseOrderShipping;
  payments?: PurchaseOrderPayment[];
  ledgers?: Ledger[];
  inquiries: Inquiry[];
  buyerCoupon?: BuyerCoupon;
  newBuyerCoupon?: BuyerCoupon;
  willBeBuyerCoupon?: BuyerCoupon;
  sampleProducts?: PurchaseOrderSampleProduct[];
  sampleProductShippingFee: number;
  orderComment: string;
  msiPrice?: number;
  pointSettingId?: number;
  pointSetting?: PointSetting;
  ledgerPayment?: Ledger;
  groupOriginCreated?: string;
  quarter?: string;
  currentQuarterBegin?: string;
  currentQuarterEnd?: string;

  setStatus(purchaseOrderStatus: PURCHASE_ORDER_ADMIN_STATUS) {
    this.purchaseOrderStatus = purchaseOrderStatus;
    this.purchaseOrderStatusUpdated = new Date();
    if (purchaseOrderStatus === PURCHASE_ORDER_ADMIN_STATUS.CANCELLED) this.cancelled = this.purchaseOrderStatusUpdated;
    if (purchaseOrderStatus === PURCHASE_ORDER_ADMIN_STATUS.REFUNDED) this.refunded = this.purchaseOrderStatusUpdated;
    return this;
  }

  calculateRefundAmount() {
    return Number(this.refundPrice + this.refundCredit + this.refundPoint);
  }
}
